import { createContext, useReducer } from "react";

export interface IRightSideBarContextProps {
    state: IRightSidebarState;
    dispatch: Function;
}

export const RightSideBarContext = createContext<IRightSideBarContextProps>(
    {} as IRightSideBarContextProps
);

export enum RightSidebarActions {
    SETITEM,
    REMOVEITEM,
    REFRESHTABLE,
}

export interface IRightSidebarState {
    component?: any;
    // Monotonic counter, incremented on every REFRESHTABLE. Consumers use it as
    // an effect dependency, so it must CHANGE on each dispatch — a sticky `true`
    // would skip refetches on a second save in the same session. (boolean kept
    // in the union for a legacy direct-mutation consumer.)
    refresh?: number | boolean;
}

export interface IRightSidebarPayload {
    action: RightSidebarActions;
    component: any;
}

export const RightSideBarProvider = (props: any) => {
    const [state, dispatch] = useReducer(
        (state: IRightSidebarState, payload: IRightSidebarPayload): IRightSidebarState => {
            switch (payload.action) {
                case RightSidebarActions.SETITEM:
                    return { component: payload.component };

                case RightSidebarActions.REMOVEITEM:
                    return { component: null };
                case RightSidebarActions.REFRESHTABLE:
                    return {
                        refresh: (typeof state.refresh === "number" ? state.refresh : 0) + 1
                    };
                default:
                    throw new Error("Undefined action provided.");
            }
        },
        {} as IRightSidebarState
    );

    return (
        <RightSideBarContext.Provider value={{ state, dispatch }}>
            {props.children}
        </RightSideBarContext.Provider>
    );
};
